import styled from 'styled-components'
import { anatomyRootCss } from '~/pages/anatomy/libs/styles'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Root: styled.div`
    ${anatomyRootCss}
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    height: 100%;
    overflow-y: auto;
  `,

  Title: styled.h1<{ $isAnatomyV2?: boolean }>`
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: ${COLORS.BLACK};
    text-align: start;
    margin-top: ${({ $isAnatomyV2 }) => ($isAnatomyV2 ? '24px' : '0')};
    margin-bottom: 24px;
  `,

  ProgressContainer: styled.div`
    margin-bottom: 32px;
  `,

  EnjoyTitle: styled.h2`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    color: ${COLORS.BLACK};
    margin-bottom: 24px;
  `,

  Review: styled.div`
    padding: 12px;
    background: ${COLORS.WHITE};
    box-shadow: 0px 4px 10px 0px #3e0b8f1a;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,

  ReviewHeader: styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
  `,

  ReviewAvatar: styled.img`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  `,

  ReviewNameBlock: styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,

  ReviewAuthor: styled.p`
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    color: ${COLORS.BLACK};
  `,

  ReviewStars: styled.img`
    height: 20px;
    width: auto;
  `,

  ReviewText: styled.p`
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK_ALPHA_50};
  `,

  Overlay: styled.div`
    position: fixed;
    inset: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
  `,

  PopupCard: styled.div`
    background: ${COLORS.WHITE};
    border-radius: 24px;
    padding: 20px 16px 16px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.16);
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,

  PopupHeader: styled.p`
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    color: ${COLORS.BLACK};
    text-align: center;
  `,

  PopupQuestion: styled.h2`
    font-size: 20px;
    line-height: 1.2;
    font-weight: 700;
    color: ${COLORS.BLACK};
    text-align: center;
  `,

  PopupButtonWrapper: styled.div`
    display: flex;
    gap: 8px;
    margin-top: 4px;
  `,

  PopupButton: styled.button`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px 8px;
    border: 1px solid ${COLORS.GRAY_400};
    border-radius: 14px;
    background: ${COLORS.WHITE};
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    color: ${COLORS.BLACK};
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  `,

  ButtonIcon: styled.img`
    width: 24px;
    height: 24px;
  `,
} as const
